<div class="container">

  <app-header-dialog [iconName]="'store_mall_directory'">
  Agenda
</app-header-dialog>

  <form name="roleForm" [formGroup]='roleForm' autocomplete="off">

    <mat-form-field class="full-width" *ngIf='!isEdit' appearance="outline">
      <mat-label>Colaborador (4 letras iniciais)</mat-label>
      <input matInput #memberSelected type="text" [matAutocomplete]="autoMember" [formControl]="roleForm.controls.member">
      <mat-autocomplete #autoMember="matAutocomplete" [displayWith]="displayMember.bind(this)">
        <mat-option *ngFor="let member of members" [value]="member">
          {{ member.name }}
          <span *ngIf="member.email"> | <small>{{ member.email }}</small></span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="full-width" *ngIf='isEdit' appearance="outline">
      <mat-label>Colaborador</mat-label>
      <input matInput type="text" readonly [formControl]="roleForm.controls.member" autocomplete="off">
    </mat-form-field>

    <mat-form-field class="full-width" *ngIf='!data.confirmed' appearance="outline">
      <mat-label>Papel</mat-label>
      <mat-select [formControl]="roleForm.controls.role_id">
        <mat-option *ngFor="let role of _agendaService.roles" [value]="role.id">
          {{ role.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="roleForm.controls.role_id.hasError('required')">
        Selecione um papel
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width" *ngIf='data.confirmed' appearance="outline">
      <mat-label>Papel</mat-label>
      <input matInput type="text" readonly [formControl]="roleForm.controls.role_name" autocomplete="off">
    </mat-form-field>


    <div class='check' *ngIf='!data.confirmed'>
      <mat-checkbox color='primary' [formControl]="roleForm.controls.requireConfirm">
        Requer confirmação
      </mat-checkbox>
    </div>

    <div class='check' *ngIf='data.dateConfirmed'>
      Confirmado em: {{data.dateConfirmed.seconds*1000 | date:'dd/MM/yyyy'}}
    </div>

  </form>


  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>


    <button mat-raised-button (click)="matDialogRef.close(['insert',roleForm])" *ngIf="!isEdit"
      [disabled]="roleForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>


    <button mat-raised-button (click)="matDialogRef.close(['update',roleForm])" [disabled]="roleForm.invalid"
      *ngIf='isEdit && (!data.confirmed || !data.scheduled_date)'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>